const configs = {
  OFFER_TYPE: {
    MODAL: 1,
    INLINE: 2,
    FULLSCREEN: 3,
  },
}

export default configs
